import { Component } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { LangChangeEvent, TranslateService } from 'ng2-translate';

import { KendoMessageService } from './core/kendo-message.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    private kendoMessageService: KendoMessageService;
    constructor(private translate: TranslateService, messageService: MessageService) {
        this.kendoMessageService = <KendoMessageService>messageService;
        this.initializeLanguage();
    }

    private initializeLanguage(): void {
        const languages: string[] = ['en', 'nl', 'fr'];

        this.translate.addLangs(languages);

        let defaultLang: string = this.translate.getBrowserLang();
        if (!defaultLang || languages.indexOf(defaultLang) === -1) {
            defaultLang = 'en';
        }

        this.translate.setDefaultLang(defaultLang);
        this.translate.use(defaultLang);

        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.kendoMessageService.language = event.lang;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts